import styled from "styled-components";

export const DatePickerWrapper = styled.div`
    position: relative;
    .react-datepicker-popper{
        zoom: 1.2;
        top: 100% !important;
    }
    .react-datepicker__input-container{
        width: 100%;
        border: 1px solid var(--colorGray);
        border-radius: 4px;
        padding: 0px;

        input{
            border: none;
            width: 100%;
            height: var(--inputHeight);
            padding: 0 10px;
            box-sizing: border-box;
            border-radius: 4px;
            outline: none;

            &.hasError{
                border: 1px solid var(--colorOrange);
            }
        }
    }
`;